export default __webpack_public_path__ + "0249bd3a0a893ae5be6f7078621741a2.png";